<template>
  <div class="border-top m-2 mt-2 p-2">
    <div class="mb-4 mt-3">
      <validation-observer :ref="'paramCreateObserver'">
        <div class="row p-2">
          <div class="col-md-3 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-input
                v-model="sysParameter.name"
                :custom-error-msg="'El nombre del parámetro es requerido.'"
                :error="errors[0]"
                label="Nombre:"
              />
            </validation-provider>
          </div>
          <div class="col-md-5 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-input
                v-model="sysParameter.description"
                :custom-error-msg="'La descripción del parámetro es requerido.'"
                :error="errors[0]"
                label="Descripción:"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="sysParameter.selectedAcademicYear"
                :custom-error-msg="'El año académico es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="description"
                label="Año Académico:"
                :options="academicYears"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-md-2 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-date-picker
                v-model="sysParameter.effectiveDate"
                :class-container="'w-100'"
                :custom-error-msg="'La fecha es requerida.'"
                :error="errors[0]"
                format="dd/MMM./yyyy"
                label="Fecha inicio:"
              />
            </validation-provider>
          </div>
          <div class="col-md-2 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-date-picker
                v-model="sysParameter.effectiveEndDate"
                :class-container="'w-100'"
                :custom-error-msg="'La fecha es requerida.'"
                :error="errors[0]"
                format="dd/MMM./yyyy"
                label="Fecha fin:"
              />
            </validation-provider>
          </div>
          <div class="col-md-4 col-sm-12 mr-md">
            <custom-input v-model="sysParameter.value" label="Valor:" />
          </div>
          <div class="col-md-2 col-sm-12 mr-md align-bottom mt-4">
            <action-button
              i="fas fa-save"
              text="Añadir"
              variant="success m-md-2 px-4"
              @click="onSaveParamHandler(sysParameter)"
            />
          </div>
        </div>
      </validation-observer>
      <hr />
    </div>
    <div
      v-for="(param, idx) in sysParameters"
      :key="`service-${idx}`"
      class="mb-3 mt-3"
    >
      <validation-observer :ref="'paramObserver'">
        <div class="row">
          <div class="col-md-2 col-sm-12 mr-md">
            <label>
              <b>{{ param.name }}</b>
            </label>
            <label>{{ param.description }}</label>
          </div>
          <div class="col-md-2 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="param.selectedAcademicYear"
                :custom-error-msg="'El año académico es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="description"
                label="Año Académico:"
                :options="academicYears"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-md-2 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-date-picker
                v-model="param.effectiveDate"
                :class-container="'w-100'"
                :custom-error-msg="'La fecha es requerida.'"
                :error="errors[0]"
                format="dd/MMM./yyyy"
                label="Fecha inicio:"
              />
            </validation-provider>
          </div>
          <div class="col-md-2 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-date-picker
                v-model="param.effectiveEndDate"
                :class-container="'w-100'"
                :custom-error-msg="'La fecha es requerida.'"
                :error="errors[0]"
                format="dd/MMM./yyyy"
                label="Fecha fin:"
              />
            </validation-provider>
          </div>
          <div class="col-md-2 col-sm-12 mr-md">
            <custom-input v-model="param.value" label="Valor:" />
          </div>
          <div class="col-md-1 col-sm-12 mr-md align-bottom mt-4">
            <action-button
              i="fas fa-save"
              text="Guardar"
              variant="success m-md-2 px-4"
              @click="onUpdateParamHandler(param, idx)"
            />
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
//import CustomInput from 'CustomInput';
import { ValidationObserver } from 'vee-validate';
import {
  getAeeConfigParams as _getAeeConfigParams,
  saveUpdateParam,
} from '@/services/common/settings.api.js';
import { getPeiAcademicYears as _getPeiAcademicYears } from '@/services/common/academicyear.api.js';
import CustomDropDown from 'custom-drop-down';
import CustomDatePicker from 'custom-date-picker';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
export default {
  name: 'SysParameters',
  components: {
    CustomDropDown,
    CustomDatePicker,
    ActionButton,
    ValidationObserver,
    CustomInput,
  },
  data() {
    return {
      sysParameter: {
        Name: '',
        Description: '',
        academicYearId: null,
        effectiveDate: null,
        effectiveEndDate: null,
        value: null,
        selectedAcademicYear: null,
      },
      showAdd: false,
      sysParameters: [],
      academicYears: [],
    };
  },
  async mounted() {
    await this.getAcademicYears();
    await this.getAeeConfigParams();
  },
  methods: {
    async getAcademicYears() {
      const { data } = await _getPeiAcademicYears();
      this.academicYears = data;
    },
    async getAeeConfigParams() {
      const { data } = await _getAeeConfigParams();
      this.sysParameters = data;

      this.sysParameters.forEach((e) => {
        e.selectedAcademicYear = this.academicYears.find(
          (a) => a.id == e.academicYearId
        );
      });
    },
    async onSaveParamHandler(sysParameter) {
      let isValid = this.$refs.paramCreateObserver.validate();

      if (!isValid) return;

      sysParameter.academicYearId = sysParameter.selectedAcademicYear?.id;
      await saveUpdateParam(sysParameter);
      await this.getAeeConfigParams();
    },
    async onUpdateParamHandler(param, idx) {
      let isValid = this.$refs.paramObserver[idx].validate();

      if (!isValid) return;

      param.academicYearId = param.selectedAcademicYear?.id;
      await saveUpdateParam(param);
      await this.getAeeConfigParams();
    },
  },
};
</script>
